/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';

import { ApiCommunityStat } from './CommunityStat';
import { ApiTodayOnTYT } from './TodayOnTYT';
import { ApiRecommendation } from './Recommendation';
import { ApiUserSnippet } from './UserSnippet';
import { ApiCommunityProject } from './CommunityProject';
import { ApiPoll } from './Poll';
import { ApiAbbreviatedForumTopic } from './AbbreviatedForumTopic';

export interface CommunityPageRequest {

    /**
     * Timestamp for when this page was cached.
     */
    cached_at?: Number;

    community_stats?: ApiCommunityStat[];

    /**
     * Today on TYT 
     */
    today_on_tyt?: ApiTodayOnTYT;

    recommended_for_you?: ApiRecommendation[];

    featured_members?: ApiUserSnippet[];

    /**
     * Featured Community Projects
     */
    community_projects?: ApiCommunityProject;

    polls?: ApiPoll[];

    petitions?: ApiPoll[];

    discussions?: ApiAbbreviatedForumTopic[];

}

@Model('CommunityPage')
export class ApiCommunityPage extends BaseModel implements CommunityPageRequest {

    /**
     * Timestamp for when this page was cached.
     */
    
    
    cached_at: Number;

    @Type('ApiCommunityStat')
    @Expand()
    community_stats: ApiCommunityStat[];

    /**
     * Today on TYT 
     */
    @Type('ApiTodayOnTYT')
    @Expand()
    today_on_tyt: ApiTodayOnTYT;

    @Type('ApiRecommendation')
    @Expand()
    recommended_for_you: ApiRecommendation[];

    @Type('ApiUserSnippet')
    @Expand()
    featured_members: ApiUserSnippet[];

    /**
     * Featured Community Projects
     */
    @Type('ApiCommunityProject')
    @Expand()
    community_projects: ApiCommunityProject;

    @Type('ApiPoll')
    @Expand()
    polls: ApiPoll[];

    @Type('ApiPoll')
    @Expand()
    petitions: ApiPoll[];

    @Type('ApiAbbreviatedForumTopic')
    @Expand()
    discussions: ApiAbbreviatedForumTopic[];

}
